var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.725,
    height: 28.418,
    viewBox: "0 0 27.725 28.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#19a4bc",
    d: "M18.077,14.27,23.05,5.682l2.4,8.588-2.4,8.586L18.077,14.27Zm-2.424,1.395,4.974,8.586-8.662-2.219L5.706,15.665ZM20.625,4.287l-4.973,8.588H5.706l6.258-6.367Zm7.1,7.061L24.691.06,13.367,3.085,11.69,6.032l-3.4-.024L0,14.271l8.289,8.261h0l3.4-.025,1.679,2.947,11.323,3.025,3.034-11.285L26,14.27l1.723-2.922Z",
    transform: "translate(0 -0.06)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnity);
export default __webpack_public_path__ + "static/media/unity.032e8ff7e79c837a4fb44a6344e6f72b.svg";
export { ForwardRef as ReactComponent };